import {MP_API_PREFIX, V1_API_PREFIX, V2_API_PREFIX, V3_API_PREFIX} from "@pg-mono/rp-api-routes";

import {rpServerMpApiUrl, rpServerV1ApiUrl, rpServerV2ApiUrl, rpServerV3ApiUrl} from "../read_rp_environment_variables";

export const serverApiUrls = {
    [V1_API_PREFIX]: rpServerV1ApiUrl,
    [V2_API_PREFIX]: rpServerV2ApiUrl,
    [V3_API_PREFIX]: rpServerV3ApiUrl,
    [MP_API_PREFIX]: rpServerMpApiUrl
};
import {MP_API_PREFIX, V1_API_PREFIX, V2_API_PREFIX, V3_API_PREFIX} from "@pg-mono/rp-api-routes";

import {rpServerMpApiUrl, rpServerV1ApiUrl, rpServerV2ApiUrl, rpServerV3ApiUrl} from "../read_rp_environment_variables";

export const serverApiUrls = {
    [V1_API_PREFIX]: rpServerV1ApiUrl,
    [V2_API_PREFIX]: rpServerV2ApiUrl,
    [V3_API_PREFIX]: rpServerV3ApiUrl,
    [MP_API_PREFIX]: rpServerMpApiUrl
};
